<div kalDialogHeader>
    <div class="kal-dialog__title">Avertissement RGPD</div>
    <kal-icon (click)="close()">close</kal-icon>
</div>

<div kalDialogContent>

    <p>
        <span *ngIf="data.isExport; else rgpdLoginMessage">
            En important ou exportant ces données, vous prenez la responsabilité du traitement qui en sera fait dans le cadre du
            règlement général européen sur la protection des données
        </span>

        <ng-template #rgpdLoginMessage>
            <span>
                En utilisant notre solution UpExpert, vous pourriez avoir accès à des données à caractère personnel
                des bénéficiaires. En imprimant ou en exportant ces données, vous prenez la responsabilité du traitement
                qui en sera fait dans le cadre du règlement général européen sur la protection des données
            </span>
        </ng-template>

        <strong>(RGPD).</strong>
    </p>

    <p>
        <a class="gup-O-link -secondary" href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees"
           target="_blank">
            https://www.cnil.fr/fr/reglement-europeen-protection-donnees
        </a>
    </p>

    <p>
        <strong>
            Veuillez vous assurer de pouvoir garantir leur confidentialité avant de les imprimer, de les extraire ou de
            les stocker sur votre poste.
        </strong>
    </p>

    <p *ngIf="!data.isExport">
        <kal-form-field class="without-label">

            <kal-checkbox id="rgpd_dialog_discard_dialog"
                          label="J'ai compris, ne plus afficher ce message"
                          [formControl]="discardDialogControl">

            </kal-checkbox>

        </kal-form-field>
    </p>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">


        <ng-container *ngIf="data.isExport else noExport">
            <div class="gup-O-list__item">
                <kal-button id="rgpd_dialog_submit"
                            kalTheme="primary"
                            (click)="submit()">
                    {{data.submitButtonLabel || 'Imprimer'}}
                </kal-button>
            </div>
            <div class="gup-O-list__item">
                <kal-button id="rgpd_dialog_cancel"
                            kalTheme="secondary"
                            (click)="close()">
                    Annuler
                </kal-button>
            </div>
        </ng-container>

        <ng-template #noExport>
            <div class="gup-O-list__item">
                <kal-button id="rgpd_dialog_cancel"
                            kalTheme="primary"
                            (click)="submit()">
                    Fermer
                </kal-button>
            </div>
        </ng-template>

    </div>

</div>
